import { useBoxBuilder } from "@/lib/store";
import type { TissuePaper } from "@/lib/types";
import { cn } from "@/lib/cn";

export default function TissueSelector({
  options,
}: {
  options: TissuePaper[];
}) {
  const tissueId = useBoxBuilder((s) => s.tissueId);
  const setTissue = useBoxBuilder((s) => s.setTissue);

  return (
    <div
      className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4"
      role="radiogroup"
      aria-label="Tissue paper"
    >
      {options.map((opt) => {
        const selected = tissueId === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => setTissue(opt.id)}
            className={cn(
              "card group relative flex flex-col items-center gap-3 p-3 text-center transition hover:-translate-y-0.5 hover:shadow-pop",
              selected && "ring-2 ring-brand-500",
            )}
          >
            <div
              className="relative h-32 w-full overflow-hidden rounded-xl sm:h-36"
              style={{ backgroundColor: opt.swatchColor ?? "#f9e4c8" }}
            >
              {opt.image ? (
                <img
                  src={opt.image}
                  alt=""
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              ) : null}
            </div>
            <span className="text-base font-semibold text-ink-800">
              {opt.title}
            </span>
            <span
              className={cn(
                "absolute right-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-full border-2 text-sm",
                selected
                  ? "border-brand-500 bg-brand-500 text-white"
                  : "border-white/80 bg-white/80 text-transparent",
              )}
              aria-hidden
            >
              {selected ? "\u2713" : ""}
            </span>
          </button>
        );
      })}
    </div>
  );
}
